import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['prefix', 'highlight']
  static values = {
    prefix: String,
    highlight: String,
    typeSpeed: { type: Number, default: 80 }
  }

  async connect() {
    this.charIndex = 0
    await this.delay(300)
    this.typePrefix()
  }

  delay(ms) {
    return new Promise(resolve => {
      const start = performance.now()
      const check = () => {
        if (performance.now() - start >= ms) {
          resolve()
        } else {
          requestAnimationFrame(check)
        }
      }
      requestAnimationFrame(check)
    })
  }

  async typePrefix() {
    if (this.charIndex <= this.prefixValue.length) {
      this.prefixTarget.textContent = this.prefixValue.substring(0, this.charIndex)
      this.charIndex++
      await this.delay(this.typeSpeedValue)
      this.typePrefix()
    } else {
      this.charIndex = 0
      this.typeHighlight()
    }
  }

  async typeHighlight() {
    if (this.charIndex <= this.highlightValue.length) {
      this.highlightTarget.textContent = this.highlightValue.substring(0, this.charIndex)
      this.charIndex++
      await this.delay(this.typeSpeedValue)
      this.typeHighlight()
    }
  }
}
